import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {useData} from '../../context/DataContext';
import { useLang} from '../../context/LanguageContext';
import { FaArrowLeft } from 'react-icons/fa';
import BgImage from '../../images/games_bg.png';
import {useAuth} from "../../context/AuthContext";
import DateUtils from "../../utils/dateUtils";
import Footer from "../../components/Footer";

const SoccerHighOddsPage = () => {
  const navigate = useNavigate();
  const { highOddsGames } = useData();
  const { t, getBetTranslation } = useLang()
  const { hasPaid } = useAuth();
  const [dayFilter, setDayFilter] = useState('all');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (!highOddsGames) {
    return (
      <div className="bg-gray-100 min-h-screen flex flex-col items-center justify-center relative">
        <button
          onClick={() => navigate(-1)}
          className="absolute top-5 left-5 px-4 py-2 bg-[#2ecc71] rounded flex items-center space-x-2"
        >
           <FaArrowLeft />
          <span className="text-white">{t('btn.back')}</span>
        </button>
        <div>Loading High Odds Games...</div>
      </div>
    );
  }

  const getGradeStyle = (grade) => {
    // grade is between 1 and 10
    const percentage = grade * 1; // e.g. grade=5 => 5% width, or you might do *10 => 50%
    // default color = red
    let bgColor = 'bg-red-500';
    if (grade >= 4 && grade < 7) {
      bgColor = 'bg-yellow-500';
    } else if (grade >= 7) {
      bgColor = 'bg-green-500';
    }
    return { percentage, bgColor };
  };

  const dayCodes = new Set();
  highOddsGames.forEach((g) => {
    const code = DateUtils.getDayCode(g.day);
    if (code) dayCodes.add(code);
  });
  const uniqueDayCodes = Array.from(dayCodes).sort();

  const dayOptions = uniqueDayCodes.map((code) => {
    const label = DateUtils.getDayLabel(code);
    return { code, label };
  });

  const filteredGames = highOddsGames.filter((game) => {
    if (dayFilter === 'all') return true;
    const code = DateUtils.getDayCode(game.day);
    return code === dayFilter;
  });

  return (
    <div className="bg-[#34495e] min-h-screen p-5 relative">
      <button
        onClick={() => navigate(-1)}
        className="absolute top-5 left-5 px-4 py-2 bg-[#2ecc71] rounded flex items-center space-x-2"
      >
        <FaArrowLeft />
        <span className="text-white">{t('btn.back')}</span>
      </button>

      <h1 className="text-white text-xl font-bold mb-4 text-center mt-16">
        {t('txt.highPredTitle')}
      </h1>

      <div className="max-w-xs mx-auto mb-4">
        <label className="block mb-1 font-semibold text-sm text-white">
         {t('txt.filterDays')}
        </label>
        <select
          className="w-full border border-gray-300 rounded px-2 py-1"
          value={dayFilter}
          onChange={(e) => setDayFilter(e.target.value)}
        >
          <option value="all">{t('txt.selectDays')}</option>
          {dayOptions.map((opt) => (
            <option key={opt.code} value={opt.code}>
              {opt.label}
            </option>
          ))}
        </select>
      </div>

      <div className="space-y-4">
        {filteredGames.map((game) => {
          const grade = game.grade || 5;
          const { percentage, bgColor } = getGradeStyle(grade);

           const translatedMarketName = getBetTranslation(game.marketName);
           const translatedMarket = getBetTranslation(game.market);

          return (
            <div
              key={game.id}
              className="
                relative rounded shadow 
                p-4 text-white bg-cover bg-center
                min-h-[140px]
                border-r-2
                border-[#27ae60]
              "
              style={{
                backgroundImage: `url(${BgImage})`,
              }}
            >
              <div className="w-full h-2 rounded mb-2 overflow-hidden">
                <div
                  className={`${bgColor} h-full`}
                  style={{ width: `${percentage}%` }}
                />
              </div>
              <p className="text-xs mb-2 text-gray-200">{percentage}% procentaj</p>
              <div className="flex items-center mb-2">
                {game.flag && (
                  <img
                    src={game.flag}
                    alt="Flag"
                    className="w-6 h-6 mr-2"
                  />
                )}
                <span className="font-bold text-sm">{game.countryName}</span>
              </div>

              <div className="text-sm font-semibold mb-1">
                {game.team1} vs {game.team2}
              </div>

              <div className="text-sm mb-2">
                <span className="mr-4">{DateUtils.formatDayOnly(game.day, t)}</span>
                <span>{game.hour}</span>
              </div>

              {hasPaid ? (
                <div className="text-sm">
                  <span>
                  {translatedMarketName} ({translatedMarket})
                  </span>
                  {' - '}
                  <span className="text-lg font-bold text-green-300">{game.odd}</span>
                </div>
              ) : (
                <button
                  onClick={() => navigate('/account')}
                  className="px-3 py-1 bg-blue-500 text-white rounded text-sm"
                >
                    {t('btn.unlockPremium')}
                </button>
              )}
            </div>
          );
        })}

        {filteredGames.length === 0 && (
          <p className="text-center text-gray-500">
            No high-odds matches found for this day.
          </p>
        )}
      </div>
        <Footer />
    </div>
  );
};

export default SoccerHighOddsPage;
